// extracted by mini-css-extract-plugin
module.exports = {"content":"ContentContainer_content__2gPhp"};